import type { HelpContent } from '../types'

/** Help panel + first-run walkthrough copy for the Inbox. Em-dash free. */
export const INBOX_HELP: HelpContent = {
  key: 'inbox',
  title: 'Inbox',
  intro:
    'The Inbox is every LinkedIn conversation with your leads in one place, including replies the AI drafts for you. It needs a connected LinkedIn account.',
  panel: [
    {
      heading: 'How it works',
      items: [
        { text: 'Pick a conversation on the left to read the full thread on the right.' },
        { text: 'When the AI drafts a reply, it can wait for your approval in the review queue at the top before it sends.' },
        { text: 'Type in the box at the bottom of a thread to reply yourself.' },
      ],
    },
    {
      heading: 'The filters',
      items: [
        { term: 'All', text: 'Every conversation, most recent first.' },
        { term: 'Attention', text: 'Unread or active threads that may need a reply from you.' },
        { term: 'Replied', text: 'Threads where the lead has written back.' },
        { term: 'Escalated', text: 'Threads the system paused after a negative or sensitive reply.' },
      ],
    },
    {
      heading: 'Status colors',
      items: [
        { text: 'A red dot is escalated, green is replied, yellow is active, and gray is paused.' },
      ],
    },
    {
      heading: 'Good to know',
      items: [
        { text: 'If you reply to a lead yourself, automatic messaging for that lead stops, so the system never talks over you.' },
        { text: 'Escalated means the system detected a negative reply and paused so you can handle it personally.' },
      ],
    },
  ],
  tour: [
    {
      id: 'welcome',
      title: 'Your conversations',
      body: 'Every LinkedIn thread with your leads, including AI-drafted replies, in one place.',
    },
    {
      id: 'review',
      target: 'inbox-review',
      title: 'The review queue',
      body: 'AI-written replies can wait here for your approval before they send.',
    },
    {
      id: 'list',
      target: 'inbox-list',
      title: 'Pick a conversation',
      body: 'Filter by All, Attention, Replied, or Escalated, then click a thread to open it.',
    },
    {
      id: 'thread',
      target: 'inbox-thread',
      title: 'Read and reply',
      body: 'The full history is on the right. Reply in the box at the bottom; doing so pauses AI for that lead.',
    },
    {
      id: 'done',
      title: 'That is the Inbox',
      body: 'Reopen this walkthrough anytime from the Help button.',
    },
  ],
}
